import { GridTimeCellComponent } from '../../../components/templates/date/date.component';
import { DateCol } from '../date/date-col';
import { TimeEditorComponent } from './time-editor.component';
import { TimeFilterComponent } from './time-filter.component';

export class TimeCol extends DateCol {
  public override getColDef() {
    return {
      ...super.getColDef(),
      ...{
        cellEditor: TimeEditorComponent,
        cellRenderer: GridTimeCellComponent,
        filter: TimeFilterComponent,
        type: 'date',
      },
    };
  }
}
